import React from "react";
import ReactDOM from "react-dom";
import SortableComponent from "./SortableComponent";

ReactDOM.render(
  <React.StrictMode>
    <SortableComponent />
  </React.StrictMode>,
  document.getElementById("root")
);
